import { useMemo } from 'react';

import { CategoryProduct } from '~/src/common/typings/category';
import { isNumber } from '~/src/common/utils/guards';

interface Props {
  items: (CategoryProduct | number)[];
  position: number;
  subcategoriesCount: number;
}

const useProductAnalytics = ({ items, position, subcategoriesCount }: Props) => {
  const numberOfProducts = items.filter(i => !isNumber(i) && i.type === 'PRODUCT').length;

  const data = useMemo(
    () => ({
      'number of products in the list': numberOfProducts,
      'number of cards in the list': items.length,
      'subcategory position': position,
      'category position': 0,
      'number of subcategories': subcategoriesCount,
    }),
    [items.length, numberOfProducts, position, subcategoriesCount],
  );

  return data;
};
export default useProductAnalytics;
